var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9969 6.94822L13.458 6.75447C13.1677 6.74566 12.939 6.50788 12.939 6.19963V5.5127H11.7603V10.2508H21.9821V7.37976L21.5423 7.36215C21.2871 7.36215 21.0672 7.18601 20.9969 6.94822Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7194 3.66412C21.6842 3.75218 21.6402 3.83145 21.5874 3.8931C21.4731 4.00759 21.3323 4.06923 21.174 4.07804L13.7144 4.27179V6.01557L21.174 6.20932C21.3587 6.21812 21.5347 6.30619 21.6402 6.45591L21.6842 6.53517C21.6842 6.54398 21.693 6.56159 21.7018 6.57921L21.7194 6.63205L21.9921 6.64086V3.6377L21.7194 3.6465C21.7194 3.65531 21.7194 3.65531 21.7194 3.66412Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7603 4.75571H12.939V4.05996C12.939 3.76052 13.1677 3.51393 13.4668 3.50512L21.0144 3.28495L21.032 3.24091C21.0408 3.23211 21.0408 3.21449 21.0496 3.20569C21.0848 3.15284 21.1112 3.10881 21.1464 3.07358L21.2343 3.00313C21.2695 2.97671 21.3311 2.94148 21.3927 2.92386L21.4367 2.91506C21.4543 2.91506 21.4718 2.90625 21.4982 2.90625H21.551L21.9996 2.88864V0.0175781H11.7778V4.75571H11.7603Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60038 2.94152V1.74377H3.94974V0H0V10.2689H3.94974V8.52511H7.60038V7.32737H9.89632L11.4006 5.13444L9.89632 2.94152H7.60038Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjection);
export default __webpack_public_path__ + "static/media/injection.46c7828596a34e50216a659cda213133.svg";
export { ForwardRef as ReactComponent };